export const twitterURL = 'https://twitter.com/intent/tweet?text='
export const shareButtonTestId = 'share-profile-button'
export const blockedButtonTestId = 'blocked-button'
export const actionsForNonBlockedTestId = 'actions-for-non-blocked'
export const walletTestId = 'profile-information-wallet'
export const MAX_DESCRIPTION_LENGTH = 180
export const MAX_NUMBER_OF_LINKS = 3
